export default {
  state: {
    hospital: [],  // 机构数据
  },
  getters: {
    hospital: state => state.hospital
  },
  mutations: {
    setHospital(state, hospital){  // 设置机构数据
      state.hospital = hospital;
    }
  },
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hospital.js